import { render, staticRenderFns } from "./StatementMovieDialog.vue?vue&type=template&id=2a7d4aed&scoped=true&"
import script from "./StatementMovieDialog.vue?vue&type=script&lang=ts&"
export * from "./StatementMovieDialog.vue?vue&type=script&lang=ts&"
import style0 from "./StatementMovieDialog.vue?vue&type=style&index=0&id=2a7d4aed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7d4aed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
